module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/BlockLinkSet-291886ac30d6948d6115715565100958.png";